import { defineComponent as b, openBlock as n, createElementBlock as u, normalizeClass as s, Fragment as c, renderList as g, createBlock as d, unref as m, withCtx as _, createElementVNode as v, createCommentVNode as y, createTextVNode as w, toDisplayString as h } from "vue";
import k from "./index60.js";
import { Tab as C } from "./index243.js";
const B = ["disabled"], N = /* @__PURE__ */ b({
  __name: "BaseTabList",
  props: {
    tabs: {},
    variant: { default: "inner" },
    size: { default: "md" },
    underline: { type: Boolean, default: !1 },
    hasBackground: { type: Boolean, default: !1 },
    selectedTabKey: { default: "" },
    fullwidth: { type: Boolean, default: !1 }
  },
  setup(l) {
    const t = l, f = (a, i = !1) => {
      const e = `focus:outline-none focus:ring-0 flex items-center gap-x-2 ${t.fullwidth && t.variant !== "button" ? "flex-1 justify-center" : ""}`;
      if (i)
        return [
          e,
          "opacity-50 cursor-not-allowed",
          t.variant === "inner" ? "px-3 py-1.5 text-[13px] leading-[16px] tracking-tight text-[var(--button-tab-text-off)]" : t.variant === "button" ? "whitespace-nowrap px-3 py-1.5 text-[13px] leading-[16px] rounded-full bg-[var(--button-disabled-background)] text-[var(--font-color-default-muted)]" : t.size === "lg" ? "py-3 px-6 text-base font-semibold text-default-muted-dark" : "px-4 py-3 text-sm font-medium text-default-muted-dark"
        ].join(" ");
      if (t.variant === "button")
        return [
          e,
          "whitespace-nowrap px-4 py-2 text-[12px] leading-[16px] tracking-tight rounded-full font-medium",
          a ? "bg-[var(--button-primary-background)] text-[var(--button-primary-text)]" : "bg-[var(--button-disabled-background)] text-[var(--font-color-default-muted)]"
        ].join(" ");
      if (t.variant === "inner")
        return [
          e,
          "px-3 py-1.5 text-[13px] leading-[16px] tracking-tight ",
          a ? "bg-[var(--button-tab-button-on)] text-[var(--button-tab-text-on)] rounded-xs font-medium" : "text-[var(--button-tab-text-off)]"
        ].join(" ");
      const o = t.size === "lg" ? a ? "py-3 px-6 text-base font-semibold" : "py-3 px-6 text-base font-normal" : a ? "px-4 py-3 text-sm font-medium" : "px-4 py-3 text-sm font-normal", r = a ? "bg-bg-bg-default text-default" : t.hasBackground ? "bg-bg-bg-surface text-default-muted-dark" : "bg-bg-bg-default text-default-muted-dark", p = a ? t.size === "lg" ? "shadow-[inset_0_-3px_0_0_var(--input-color-border-focus)]" : "shadow-[inset_0_-2px_0_0_var(--input-color-border-focus)]" : t.underline ? t.size === "lg" ? "shadow-[inset_0_-3px_0_0_var(--background-bg-outline)]" : "shadow-[inset_0_-2px_0_0_var(--background-bg-outline)]" : "";
      return [e, "whitespace-nowrap ", o, r, p].filter(Boolean).join(" ");
    }, x = () => t.variant === "inner" ? "flex p-1 bg-neutral-neutral050 rounded-[6px] gap-x-[10px]" : t.variant === "button" ? t.fullwidth ? "flex w-full gap-x-1" : "flex flex-nowrap gap-x-1" : t.fullwidth ? "flex w-full" : "flex flex-nowrap";
    return (a, i) => (n(), u("div", {
      class: s(x())
    }, [
      (n(!0), u(c, null, g(l.tabs, (e, o) => (n(), d(m(C), {
        as: "template",
        key: o,
        disabled: e.disabled
      }, {
        default: _(({ selected: r }) => [
          v("button", {
            class: s(f(r, e.disabled)),
            disabled: e.disabled
          }, [
            e.icon ? (n(), d(k, {
              key: 0,
              name: e.icon
            }, null, 8, ["name"])) : y("", !0),
            w(" " + h(e.label), 1)
          ], 10, B)
        ]),
        _: 2
      }, 1032, ["disabled"]))), 128))
    ], 2));
  }
});
export {
  N as default
};
